export default __webpack_public_path__ + "static/media/festival-gate.96754217.webp";